var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514.3,380c-1.8,21.1-19.4,37.6-40.8,37.6c-22.6,0-41-18.3-41-41s18.3-41,40.9-41c22.8,1,40.8,19.7,40.8,42.6 C514.3,378.8,514.3,379.4,514.3,380L514.3,380L514.3,380z M327.5,335.7c-22.9,2-40.8,21.1-40.8,44.4c0,23.3,17.8,42.4,40.6,44.4h0.2 c22.8-1,40.8-19.7,40.8-42.6c0-0.6,0-1.2,0-1.9v0.1c0-0.7,0.1-1.4,0.1-2.2c0-22.8-18-41.4-40.6-42.3h-0.1L327.5,335.7z M750,82.4 V800c-100.8-89.1-68.6-59.6-185.6-168.4l21.2,74H132c-45.3-0.1-82-36.9-82-82.2c0-0.1,0-0.1,0-0.2V82.4c0-0.1,0-0.1,0-0.2 c0-45.3,36.7-82.1,82-82.2h536c45.3,0.1,82,36.9,82,82.2L750,82.4L750,82.4z M636,461.6c-1.4-85.3-22.5-165.3-59-236.2l1.4,3 c-30.8-24.4-69.6-39.8-111.9-42l-0.5,0l-5.6,6.4c38.3,10.4,71.7,27.9,100.1,51.2l-0.5-0.4c-46.6-25.6-102.2-40.7-161.3-40.7 c-49.8,0-97,10.7-139.6,29.9l2.1-0.9c-14.8,6.8-23.6,11.7-23.6,11.7c29.5-24.1,64.7-42.2,103.3-52l1.9-0.4l-4-4.8 C296,188.6,257.2,204,226,228.7l0.4-0.3c-35.1,67.9-56.2,147.9-57.6,232.7v0.5c26.6,37,69.6,60.9,118.1,60.9c1.4,0,2.7,0,4.1-0.1 h-0.2c0,0,14.8-18,26.8-33.2c-28.9-7.4-53.1-24.2-69.8-46.9l-0.2-0.3c5.9,4.1,15.6,9.5,16.3,10c40.3,22.4,88.4,35.6,139.6,35.6 c39.7,0,77.5-7.9,112-22.3l-1.9,0.7c17.6-6.7,32.7-14.7,46.8-24.1l-0.8,0.5c-17.5,23.4-42.6,40.4-71.5,47.4l-0.9,0.2 c12,15.2,26.4,32.4,26.4,32.4c1.1,0,2.4,0,3.7,0c48.7,0,91.8-23.8,118.4-60.4L636,461.6L636,461.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.6590d24fd64f7c6bde78f2e9e7a82a35.svg";
export { ForwardRef as ReactComponent };